import React, { Component } from "react";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default class EditPoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      target_from: "",
      client_id: "",
      staff_id: "",
      target_flag: "",
      job_id: "",
      memo: "",
      add_point: "",
      minus_point: ""
    };
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleEditPoint = this.handleEditPoint.bind(this);
    this.handleRedirect = this.handleRedirect.bind(this);
  }

  componentDidMount() {
    //get current menu
    const pointId = this.props.match.params.id;
    axios
      .get("/api/points/" + pointId)
      .then(response => {
        this.setState({
          id: response.data.id,
          target_from: response.data.target_from,
          client_id: response.data.client_id,
          staff_id: response.data.staff_id,
          target_flag: response.data.target_flag,
          job_id: response.data.job_id,
          helper_ticket_id: response.data.helper_ticket_id,
          memo: response.data.memo,
          add_point: response.data.add_point,
          minus_point: response.data.minus_point
        });
      })
      .catch(error => {
        this.props.history.push("/_404");
      });
  }

  /**
   * Handle change field
   */
  handleFieldChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  /**
   * Handle create point
   */
  handleEditPoint() {
    const dataPoint = {
      memo: this.state.memo
    };
    axios
      .put("/api/points/edit/" + this.state.id, dataPoint)
      .then(response => {
        if (response.data.hasOwnProperty("success") && response.data.success) {
          this.props.history.push("/points");
        } else {
          Object.keys(response.data.errors).map((key, i) => {
            if ($.isArray(response.data.errors[key])) {
              response.data.errors[key].map((child, i) => {
                toast.error(child);
              });
            } else {
              toast.error(response.data.errors[key]);
            }
          });
        }
      })
      .catch(error => {
        Object.keys(error.response.data.errors).map((key, i) => {
          if ($.isArray(error.response.data.errors[key])) {
            error.response.data.errors[key].map((child, i) => {
              toast.error(child);
            });
          } else {
            toast.error(error.response.data.errors[key]);
          }
        });
      });
  }

  /**
   * Handle redirect
   */
  handleRedirect(e) {
    e.preventDefault();
    this.props.history.push(e.currentTarget.getAttribute("href"));
  }
 
  renderIdType() {
    let thisstate = this.state;
    if (thisstate.job_id) {
        return (
          <div className="form-group row">
          <label className="col-sm-4 col-form-label text-right">
            依頼ID
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              disabled
              value={this.state.job_id}
              className="form-control"
              placeholder="依頼ID"
            />
          </div>
        </div>
        );
    } else if(thisstate.helper_ticket_id){
      return (
        <div className="form-group row">
        <label className="col-sm-4 col-form-label text-right">
          チケット申込みID
        </label>
        <div className="col-sm-8">
          <input
            type="text"
            disabled
            value={this.state.helper_ticket_id}
            className="form-control"
            placeholder="チケット申込みID"
          />
        </div>
      </div>
      );

    }
}
  render() {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/home">
                    ダッシュボード
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <a onClick={this.handleRedirect} href="/points">
                    報酬履歴一覧
                  </a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  報酬編集
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <main id="main">
          <div className="row justify-content-md-center">
            <div className="col-sm-6">
              <div className="card mb-3">
                <div className="card-header p-4 border-bottom-0">
                  <h4 className="mb-0">報酬編集</h4>
                </div>
                <div className="card-body">
                  <h4>付与元</h4>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      タイプ
                    </label>
                    <div className="col-sm-8">
                      <select
                        disabled
                        className="form-control type_1"
                        value={
                          this.state.target_from ? this.state.target_from : ""
                        }
                      >
                        <option value="">選択してください</option>
                        <option value="3">運営</option>
                        <option value="1">依頼者</option>
                        <option value="2">ワーカー</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row type_1_client">
                    <label className="col-sm-4 col-form-label text-right">
                      依頼者ID
                    </label>
                    <div className="col-sm-8">
                      <input
                        disabled
                        type="text"
                        value={
                          this.state.target_from == 1
                            ? this.state.client_id
                            : ""
                        }
                        className="form-control"
                        placeholder="依頼者ID"
                      />
                    </div>
                  </div>
                  <div className="form-group row type_1_staff">
                    <label className="col-sm-4 col-form-label text-right">
                      ワーカーID
                    </label>
                    <div className="col-sm-8">
                      <input
                        disabled
                        type="text"
                        value={
                          this.state.target_from == 2 ? this.state.staff_id : ""
                        }
                        className="form-control"
                        placeholder="ワーカーID"
                      />
                    </div>
                  </div>
                  <p id="test"></p>
                  <h4>付与先</h4>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      タイプ
                    </label>
                    <div className="col-sm-8">
                      <select
                        disabled
                        className="form-control type_2"
                        value={
                          _.includes([1, 2], this.state.target_flag)
                            ? this.state.target_flag
                            : 3
                        }
                      >
                        <option value="">選択してください</option>
                        <option value="3">運営</option>
                        <option value="1">依頼者</option>
                        <option value="2">ワーカー</option>
                      </select>
                    </div>
                  </div>
                  <div className="form-group row type_2_client">
                    <label className="col-sm-4 col-form-label text-right">
                      依頼者ID
                    </label>
                    <div className="col-sm-8">
                      <input
                        disabled
                        value={
                          this.state.target_flag == 1 &&
                          this.state.target_from == 3
                            ? this.state.client_id
                            : ""
                        }
                        type="text"
                        className="form-control"
                        placeholder="依頼者ID"
                      />
                    </div>
                  </div>
                  <div className="form-group row type_2_staff">
                    <label className="col-sm-4 col-form-label text-right">
                      ワーカーID
                    </label>
                    <div className="col-sm-8">
                      <input
                        disabled
                        value={
                          this.state.target_flag == 2 &&
                          this.state.target_from == 3
                            ? this.state.staff_id
                            : ""
                        }
                        type="text"
                        className="form-control"
                        placeholder="ワーカーID"
                      />
                    </div>
                  </div>
                  <hr></hr>
                  {this.renderIdType()}
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      金額
                    </label>
                    <div className="col-sm-8">
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <span className="input-group-text">¥</span>
                        </div>
                        <input
                          type="text"
                          disabled
                          value={
                            this.state.target_from == 3
                              ? this.state.add_point
                              : this.state.minus_point
                          }
                          className="form-control"
                          placeholder="金額"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-sm-4 col-form-label text-right">
                      摘要
                    </label>
                    <div className="col-sm-8">
                      <textarea
                        name="memo"
                        onChange={this.handleFieldChange}
                        className="form-control"
                        value={this.state.memo}
                        rows="8"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-center">
                  <button
                    onClick={this.handleEditPoint}
                    className="btn btn-primary btn-radius btn-lg"
                  >
                    <span className="size-inherit">保存する</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </React.Fragment>
    );
  }
}
